import React, {FC, useEffect, useState} from "react";
import {Card, Form, Select} from "antd";
import {AdminDesignManagement} from "../admin-design-management.type";
import Service1FormPros = AdminDesignManagement.Service1FormPros;

const ServiceFrom: FC<Service1FormPros> = (props: Service1FormPros) => {
    const [infoList, setInfoList] = useState([]);

    useEffect(() => {
        props.form.setFieldsValue(props.configData['ru']);
    }, [props.selectedItem]);

    useEffect(() => {
        if (props.infoServices) {
            if (props.infoServices.page
                && props.infoServices.page.regions
                && props.infoServices.page.regions.mainComp
                && props.infoServices.page.regions.mainComp.components
            ) {
                const [c] = props.infoServices.page.regions.mainComp.components;

                if (c && c.config && c.config.service_list) {
                    let list = [];

                    c.config.service_list
                        .forEach((x, i)=> {
                            list.push({
                                value: i.toString(),
                                label: x.name
                            });
                        });

                    setInfoList(list);
                }
            }
        }
    }, [props.infoServices]);

    return (
        <Form form={props.form} layout="vertical">
            <Card title="Сервисы" className="mt-3">
                <Form.Item
                    label="Ссылка 1"
                    name="serviceLink1"
                >
                    <Select options={infoList}/>
                </Form.Item>

                <Form.Item
                    label="Ссылка 2"
                    name="serviceLink2"
                >
                    <Select options={infoList}/>
                </Form.Item>

                <Form.Item
                    label="Ссылка 3"
                    name="serviceLink3"
                >
                    <Select options={infoList}/>
                </Form.Item>

                <Form.Item
                    label="Ссылка 4"
                    name="serviceLink4"
                >
                    <Select options={infoList}/>
                </Form.Item>
            </Card>
        </Form>
    );
};

export default ServiceFrom;
